import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const DebitForm = ({ isOpen, onClose }) => {
    const [vendorData, setVendorData] = useState([]);
    const [formData, setFormData] = useState({
        amount: '',
        date: '',
        description: ''
    });

    useEffect(() => {
        const fetchVendors = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/vendors/all_vendors`);
                if (response.status === 200) {
                    const formattedVendors = response.data.vendor.map(vendor => ({
                        id: vendor.id,
                        vendortitle: vendor.vendortitle,
                        vendorPhone: vendor.phone,
                        vendorAddress: vendor.address,
                        vendorLpo: vendor.lponumber
                    }));
                    setVendorData(formattedVendors);
                } else {
                    console.error(`Error: ${response.status} - ${response.statusText}`);
                }
            } catch (error) {
                console.error(error);
            }
        };
        fetchVendors();
    }, []);

    const handleVendorChange = selectedVendorName => {
        const selectedVendor = vendorData.find(vendor => vendor.vendortitle === selectedVendorName);
        if (selectedVendor) {
            setFormData({
                ...formData,
                amount: '',
                date: '',
                description: '',
                vendorid: selectedVendor.id,
                vendorphone: selectedVendor.vendorPhone,
                vendoraddress: selectedVendor.vendorAddress,
                vendorlpo: selectedVendor.vendorLpo,
                vendorname: selectedVendor.vendortitle
            });
        }
    };

    const handleInputChange = event => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const addDebit = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/debits/add_debit`, {
                formData
            })
            if (res.status >= 200 && res.status < 300) {
                toast("Debit Note created successfully!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleSubmit = event => {
        event.preventDefault();
        addDebit()
        setFormData({
            ...formData,
            amount: '',
            date: '',
            description: ''
        });
    };

    return (
        <div className='z-[99999999999]' style={{ display: isOpen ? 'block' : 'none' }}>
            <div style={{ background: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }} onClick={onClose}></div>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className='md:w-[50%] rounded-md' style={{ background: '#fff', position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', padding: '20px', zIndex: 999 }}>
                <div className='flex flex-col justify-center items-center gap-1'>
                    <form className='flex flex-col justify-center items-center gap-3' onSubmit={handleSubmit} style={{ width: '90%' }}>

                        <select name="vendorname" value={formData.vendorname} onChange={e => handleVendorChange(e.target.value)} style={{ width: '100%', padding: '0.5rem', borderRadius: '0.5rem', border: '1px solid #ccc' }}>
                            <option className='disabled' value="">Select Vendor</option>
                            {vendorData.map(vendor => (
                                <option key={vendor.id} value={vendor.vendortitle}>{vendor.vendortitle} (ID:{vendor.id})</option>
                            ))}
                        </select>

                        <input
                            type="text"
                            name="amount"
                            value={formData.amount}
                            onChange={handleInputChange}
                            placeholder="Amount"
                            required
                            style={{ width: '100%', padding: '0.5rem', borderRadius: '0.5rem', border: '1px solid #ccc' }}
                        />

                        <input
                            type="date"
                            name="date"
                            value={formData.date}
                            onChange={handleInputChange}
                            placeholder="Date"
                            required
                            style={{ width: '100%', padding: '0.5rem', borderRadius: '0.5rem', border: '1px solid #ccc' }}
                        />

                        <input
                            type="text"
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            placeholder="description (any)"
                            style={{ width: '100%', padding: '0.5rem', borderRadius: '0.5rem', border: '1px solid #ccc' }}
                        />

                        <button type="submit" style={{ width: '100%', padding: '0.5rem', borderRadius: '0.5rem', border: 'none', backgroundColor: '#007bff', color: '#fff', cursor: 'pointer' }}>Create Debit Note</button>
                    </form>
                    <button onClick={onClose} style={{ width: '90%', padding: '0.5rem', borderRadius: '0.5rem', border: 'none', backgroundColor: '#6c757d', color: '#fff', cursor: 'pointer', marginTop: '1rem' }}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default DebitForm;
